// https://chir.ag/projects/name-that-color/#2D4A5D
export enum NamedColors {
  ALTO = '#DDDDDD',
  AMARANTH = '#EE2A4F',
  APPLE = '#2ECC40',
  BLACK = '#000000',
  ELECTRICAL_VIOLET = '#912DFF',
  GRAY = '#808080',
  RADICAL_RED = '#FF2D55',
  RED_ORANGE = '#FF4136',
  SCHOOL_BUS_YELLOW = '#FFDC00',
  WHITE = '#FFFFFF',
}
